import classNames from 'classnames';
import styles from './FormfieldTextarea.module.scss';
import { ErrorMessage, Label, LabelProps } from 'ui/components';

type State = {
	required?: boolean;
	disabled?: boolean;
	hasError?: boolean;
	isHidden?: boolean;
};

export interface FormfieldTextareaProps {
	className?: string;
	defaultValue?: string;
	id: string;
	name?: string;
	placeholder?: string;
	register?: any;
	errorMessage?: string;
	rows?: number;
	label: string;
	labelStyle?: LabelProps['labelStyle'];
	variant?: 'default' | 'website';
	state?: State;
}

const ariaLabel = (state: State, label: string) => {
	if (state?.['isHidden']) return label;
};

const ariaError = (state: State, name: string, id: string) => {
	if (state?.['hasError']) return name + id;
};

export const FormfieldTextarea: React.FC<FormfieldTextareaProps> = ({
	className,
	state,
	id,
	label,
	labelStyle,
	variant,
	placeholder,
	register,
	errorMessage,
	defaultValue,
	rows,
	name,
}) => {
	const { required, disabled, hasError, isHidden } = state ?? {};

	return (
		<div className={classNames(styles.FormfieldTextarea, className, { [styles.hasError]: hasError }, { [styles.isDisabled]: disabled })}>
			{!isHidden && (
				<Label
					id={id}
					className={classNames(styles.FormfieldTextarea_label, styles[`FormfieldTextarea_label___${labelStyle}`])}
					state={state}
					labelStyle={labelStyle}
				>
					{label}
				</Label>
			)}
			<textarea
				className={classNames(styles.FormfieldTextarea_input, styles[`FormfieldTextarea_input___${variant}`], {
					[styles.hasError]: hasError,
				})}
				name={name}
				id={id}
				aria-label={ariaLabel(state, label)}
				aria-describedby={ariaError(state, name, id)}
				disabled={disabled}
				placeholder={placeholder}
				defaultValue={defaultValue}
				rows={rows || 5}
				{...(register && { ...register(name, { required }) })}
			/>
			{hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
		</div>
	);
};
